import { useMount } from 'ahooks';
import { useAppDispatch } from 'app/hooks';
import { RevxSkeleton } from 'components';
import { JobConfig } from 'domains/jobconfigDomain';
import { MultiTypeEnum, SKU } from 'domains/skuDomain';
import { JobItem } from 'domains/workspaceDomain';
import { SkuUploadFile } from 'features/JobConfig/components/SkuUploadFile';
import 'features/JobConfig/ConfigStep/Step10AddFiles.less';
import { useUser } from 'hooks';
import { useSkipArtworkUploadFile } from 'hooks/useSkipArtworkUploadFile';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import jobconfigService from 'services/jobconfigService';
import skuService from 'services/skuService';
import { isBuyer } from 'utils/rbac';
import './BuyerFiles.less';

export const BuyerQuoteFiles = (jobData: JobItem) => {
  const user = useUser();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const [sku, setSku] = useState<SKU>();
  const [configItem, setConfigItem] = useState<JobConfig>();
  const isWrapperSku = sku?.multiType === MultiTypeEnum.WRAPPER;

  useMount(async () => {
    setLoading(true);
    // dispatch.workspace.getJobItemCount(jobData.id);
    dispatch.jobConfig.reset();
    if (jobData.quoteId) {
      const config = await jobconfigService.getJobConfigFromCache(
        jobData.quoteId
      );

      const skuDetail = await skuService.startViewSku(
        {
          id: jobData.skuId,
        },
        true
      );

      setSku(skuDetail);
      setConfigItem(config);
    }
    setLoading(false);
  });

  const disabledUploadFile = useSkipArtworkUploadFile(jobData);

  const canUploadFile = () => {
    if (isBuyer(user)) {
      return !jobData.isProxied;
    }
    return true;
  };
  const canDeleteFile = !(isBuyer(user) && jobData.isProxied);
  const isOwnJob = jobData?.customerId === user?.userId;

  return (
    <div className="buyer-files-card">
      <RevxSkeleton loading={loading}>
        {isOwnJob && jobData.isProxied ? (
          <span>{t('workspace.detail.supplierFiles.awaitFiles')}</span>
        ) : (
          <>
            <header>
              <p>{t('workspace.detail.files.attachFiles')}</p>
            </header>
            {configItem &&
              (isWrapperSku ? (
                <div>
                  {(sku?.parts || []).map((partSku) => {
                    return (
                      <div className="add-files-section">
                        <div className="add-files-item-title">
                          {partSku.part.name}
                        </div>
                        <div style={{ paddingLeft: 20 }}>
                          <SkuUploadFile
                            disabled={disabledUploadFile}
                            configItem={configItem}
                            sku={partSku.part}
                            jobItem={jobData}
                            onUpdate={(config: JobConfig) => {
                              setConfigItem(config);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div className="add-files-section">
                    <div className="add-files-item-title">Other Files</div>
                    <div style={{ paddingLeft: 20 }}>
                      <SkuUploadFile
                        disabled={disabledUploadFile}
                        configItem={configItem}
                        sku={sku}
                        jobItem={jobData}
                        onUpdate={(config: JobConfig) => {
                          setConfigItem(config);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="add-files-section">
                  <SkuUploadFile
                    disabled={!canUploadFile() || disabledUploadFile}
                    canDelete={canDeleteFile}
                    configItem={configItem}
                    sku={sku}
                    jobItem={jobData}
                    onUpdate={(config: JobConfig) => {
                      setConfigItem(config);
                    }}
                  />
                </div>
              ))}
          </>
        )}
      </RevxSkeleton>
    </div>
  );
};
